module.exports = __webpack_public_path__ + "img/0.1.e5ed6b83.png";